import { types } from 'mobx-state-tree'
import { user_by_id } from '../api'
import object_value from '../api/object_value'
import moment from 'moment/moment'
import 'moment-timezone'

const default_event = {
  date: null,
  date_day: null,
  date_time: null,
  date_end_time: null,
  show_time_picker: false
}

const CreateExperienceStore = types.model({
  // experience: types.optional(types.frozen, {}),
  // step: types.optional(types.number, 1),
  // created: types.optional(types.boolean, false),
  events: types.optional(types.frozen, []),
  duration: types.optional(types.number, -1)
}).views(
  /**
   * @param {Object} self
   * @returns {Object}
   */
  self => ({
    get events_dates () {
      const events = self.events
      if (!Array.isArray(events) || events.length < 1) {
        return false
      }
      return events.map(event => {
        let date = event.date
        // Convert from [ new Date(), ... ] to [ { date: new Date() }, ... ]
        // Fix: if date is `null` not convert it
        console.log('events_dates - date', date)
        if (date && date instanceof moment) {
          let formatted_date = date.format('YYYY-MM-DD[T]HH:mm:ss[Z]')
          // console.log('events_dates - date z1', formatted_date)
          // console.log('events_dates - date z2', date.toDate().toISOString().split('.')[0] + 'Z')
          return {
            date: formatted_date
          }
        }
      })
    }
  })
).actions(
  /**
   * @param {Object} self
   * @returns {Object}
   */
  self => ({
    set(key, value) {
      self[key] = value
    },
    clean() {
      self.events = [default_event]
      self.duration = -1
    },
    event__add() {
      self.events = [
        ...self.events,
        default_event
      ]
    },
    event__remove(index) {
      self.events = [
        ...self.events.slice(0, index),
        ...self.events.slice(index + 1)
      ]
    },
    event__update(index, data) {
      const events = [...self.events]
      const event = events[index]
      events[index] = {
        ...events[index],
        ...data
      }
      self.events = events
      console.log('event__update - events:', self.events)
    },
    format_time (time) {
      if (!(time > -1)) {
        return false
      }
      time = parseInt(time)

      if (time > (24 * 60)) {
        time = time - (24 * 60)
      }

      let duration = moment.duration(time, 'minutes')
      let padToTwo = number => number <= 99 ? ('0' + number).slice(-2) : number
      return padToTwo(duration.hours()) + ':' + padToTwo(duration.minutes())
    },
    calculate__event_end_time (index) {
      let date_end_time = self.events[index].date_end_time
      if (date_end_time !== null) {
        return date_end_time
      }
      let duration = self.duaration || 0
      return parseInt(self.date_time) + parseInt(duration)
    },
    format__event_time_label (index) {
      let date_time = self.events[index].date_time

      if (index !== 0) {
        let option = self.time_options(index).find(option => {
          console.log('xxx', option)
          return parseInt(option.value) === parseInt(date_time)
        })
        return object_value(option, 'label') || 'Time'
      }

      let format_end_time = self.format_time(self.calculate__event_end_time(index))
      format_end_time = format_end_time
        ? ' bis ' + format_end_time
        : ''

      return date_time
        ? self.format_time(date_time) + format_end_time + ' Uhr'
        : 'Time'
    },
    format__event_time_option_label (minutes) {
      return self.format_time(minutes) + ' bis ' + self.format_time(minutes + self.duration) + ' Uhr'
    },
    time_options (index) {
      return Array.from(new Array(48), (val, array_index) => {
        let minutes = array_index * 30
        return {
          value: minutes,
          label: index === 0
            ? self.format_time(minutes) + ' Uhr'
            : self.format__event_time_option_label(minutes)
        }
      })
    }
  })
)

export default CreateExperienceStore


// WEBPACK FOOTER //
// ./src/stores/CreateExperienceStore.js